//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory3', {
//        templateUrl: 'views/components/views/textileModelCategory3/textileModelCategory3.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'textileModelCategory3Service', function ($stateParams, stateService, translateService, modalService, textileModelCategory3Service) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory3Keyno = $stateParams.textilemodelcategory3_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                textileModelCategory3Keyno: textileModelCategory3Keyno,
//                textileModelCategory3LangNameButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('textilemodelcategory3lang', { textilemodelcategory3_keyno: vm.model.edit.textilemodelcategory3_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await textileModelCategory3Service.getTextileModelCategory3({ textilemodelcategory3_keyno: textileModelCategory3Keyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory3Service.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();		
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
